<div class="w-100 mt-2" [formGroup]="fourYearLossHistoryFormGroup">
    
    <div class="edit-table">
        <div style="display:flex; justify-content:space-between; align-items:center;">
            <h3>Loss History Details</h3>
            <span class="text-lg-right float-lg-right">
                <button class="btnsuccess mr-2" title="Add Loss" name="reset" id="reset" data-toggle="modal"
                    (click)="popUpDialogForAddLoss()" type="button">
                    Add Loss
                </button>
            </span>
        </div>
            
            <p-table class="table llh_table"
                [value]="fourYearLossHistoryFormGroup?.lossHistoryList"
                [ngStyle]="{ 'margin-bottom': '0rem' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="text-center">Valuation Date</th>
                        <th class="text-center">Prior Carrier</th>
                        <th class="text-center">Date of Loss</th>
                        <th class="text-center">Type of Loss</th>
                        <th class="text-center">Indemnity Reserved</th>
                        <th class="text-center">Indemnity Paid</th>
                        <th class="text-center">Expense Reserved</th>
                        <th class="text-center">Expense Paid</th>
                        <th class="text-center">Recovery</th>
                        <th class="text-center">Total Incurred</th>
                        <th class="text-center">Loss Status</th>
                        <th class="text-center">Action</th>
                    </tr>
                </ng-template>
                <ng-template let-product let-i="rowIndex" pTemplate="body">
                    @if (fourYearLossHistoryFormGroup?.lossHistoryFormArray?.at(i); as currentFG) {
                        <tr [formGroup]="currentFG">
                                <td class="text-center">{{ product?.valuationDate?.answer | date: 'MM/dd/yyyy' }}</td>
                                <td class="text-center">{{ product?.priorCarrier?.answer }}</td>
                                <td class="text-center">{{ product?.dateofLoss?.answer | date: 'MM/dd/yyyy' }}</td>
                                <td class="text-center text-break">{{ product?.typeOfLoss?.answer }}</td>
                                <td class="text-center">{{ product?.indemnityReserved?.answer | currency:'USD' : 'symbol' : '1.0-0' }}</td>
                                <td class="text-center">{{ product?.indemnityPaid?.answer | currency:'USD' : 'symbol' : '1.0-0' }}</td>
                                <td class="text-center">{{ product?.expenseReserved?.answer | currency:'USD' : 'symbol' : '1.0-0' }}</td>
                                <td class="text-center">{{ product?.expensePaid?.answer | currency:'USD' : 'symbol' : '1.0-0' }}</td>
                                <td class="text-center">{{ product?.recovery?.answer | currency:'USD' : 'symbol' : '1.0-0' }}</td>
                                <td style="text-align: center;">{{ product?._totalIncurred | currency:'USD' : 'symbol' : '1.0-0' }}</td>
                                <td class="text-center">{{ product?.lossStatus?.answer }}</td>
                                <td style="text-align: center; font-size: 19px;">
                                    <button type="button" class="menu-btn" 
                                        (click)="openMenu($event, i, menuUpdateLossDetails)">
                                        <i class="pi pi-ellipsis-h"></i>
                                    </button>
                                </td>
                        </tr>
                    }
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="12" class="text-center">No records found</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-menu #menuUpdateLossDetails [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
            @if (fourYearLossHistoryFormGroup.isValidValuationDate) {
                <div>
                    <span style="color: red;">Updated Loss runs will be required before binding.</span>
                </div>
            }
            @if (isSubmitted && (fourYearLossHistoryFormGroup.lossHistoryFormArray?.length == 0 || fourYearLossHistoryFormGroup.newLossHistory?.hasTouched)) {
                <span class="m-3" style="color:red;">Please click on "Add Loss" button and insert value to save the loss detail.</span>
            }
    </div>

    <p-dialog [header]="fourYearLossHistoryFormGroup.selectedRowIndex !== null ? '&emsp;Edit Loss' : '&emsp;Add Loss'" [visible]="shallDiplayDialog()"
        (visibleChange)="onDialogClose($event)" class="dialog_bulk_edit edit-user-popup loss-dialog" [modal]="true">
        <div class="row">
            <div class="col-lg-12 editUser">
                <p-card>
                    @if (fourYearLossHistoryFormGroup.get('newLossFormGroup'); as newFG) {
                        <ng-container [formGroup]="newFG">
                            <div class="row mb-3">
                                <div class="col">
                                    <div>
                                        <label for="valuationDate">Valuation Date</label>
                                    </div>
                                    <div>
                                        <p-datepicker id="valuationDate" name="valuationDate" dateFormat="mm/dd/yy" [showIcon]="true"
                                            inputId="valuationDate" dateMask
                                            [class.validate_error_cls_dp]="isAddEditButtonClicked && newFG.get('valuationDate')?.invalid"
                                            placeholder="MM / DD / YYYY" appendTo="body"
                                            formControlName="valuationDate" [maxDate]="maxDate">
                                        </p-datepicker>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="priorCarrier">Prior Carrier</label>
                                    </div>
                                    <div>
                                        <p-select id="priorCarrier" class="prior-drp" name="priorCarrier" [filter]="true"
                                            [options]="lossHistoryPriorCarrier" editable="true"
                                            [class.validateDrodown]="isAddEditButtonClicked && newFG.get('priorCarrier')?.invalid"
                                            appendTo="body" formControlName="priorCarrier" placeholder="Select">
                                        </p-select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="dateofLoss">Date of Loss</label>
                                    </div>
                                    <div>
                                        <p-datepicker id="dateofLoss" name="dateofLoss" dateFormat="mm/dd/yy" [showIcon]="true"
                                            inputId="dateofLoss" dateMask
                                            [class.validate_error_cls_dp]="isAddEditButtonClicked && newFG.get('dateofLoss')?.invalid"
                                            placeholder="MM / DD / YYYY" appendTo="body"
                                            formControlName="dateofLoss" [maxDate]="maxDate">
                                        </p-datepicker>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="typeOfLoss">Type of Loss</label>
                                    </div>
                                    <div>
                                        <p-select id="typeOfLoss" name="typeOfLoss" [options]="typeOfLoss" [filter]="true"
                                            [class.validateDrodown]="isAddEditButtonClicked && newFG.get('typeOfLoss')?.invalid"
                                            appendTo="body" formControlName="typeOfLoss" placeholder="Select" editable="true">
                                        </p-select>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="indemnityReservedAmount">Indemnity Reserved</label>
                                    </div>
                                    <div>
                                        <p-inputnumber id="indemnityReservedAmount" name="indemnityReservedAmount" mode="currency"
                                            value="" placeholder="Enter Reserved Amount $0" locale="en-US" currency="USD"
                                            [class.invalidInputNumber]="isAddEditButtonClicked && newFG.get('indemnityReserved')?.invalid"
                                            formControlName="indemnityReserved" autocomplete="off" [min]="0" [maxFractionDigits]="0">
                                        </p-inputnumber>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col">
                                    <div>
                                        <label for="indemnityPaidAmount">Indemnity Paid</label>
                                    </div>
                                    <div>
                                        <p-inputnumber id="indemnityPaidAmount" name="indemnityPaidAmount" mode="currency" value=""
                                            placeholder="Enter Paid Amount $0" locale="en-US" currency="USD"
                                            [class.invalidInputNumber]="isAddEditButtonClicked && newFG.get('indemnityPaid')?.invalid"
                                            formControlName="indemnityPaid" autocomplete="off" [min]="0" [maxFractionDigits]="0">
                                        </p-inputnumber>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="expenseReservedAmount">Expense Reserved</label>
                                    </div>
                                    <div>
                                        <p-inputnumber id="expenseReservedAmount" name="expenseReservedAmount" mode="currency"
                                            value="" placeholder="Enter Expense Reserved Amount $0" locale="en-US" currency="USD"
                                            [class.invalidInputNumber]="isAddEditButtonClicked && newFG.get('expenseReserved')?.invalid"
                                            formControlName="expenseReserved" autocomplete="off" [min]="0" [maxFractionDigits]="0">
                                        </p-inputnumber>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="expensePaidAmount">Expense Paid</label>
                                    </div>
                                    <div>
                                        <p-inputnumber id="expensePaidAmount" name="expensePaid" mode="currency" value=""
                                            placeholder="Enter Expense Paid Amount $0" locale="en-US" currency="USD"
                                            [class.invalidInputNumber]="isAddEditButtonClicked && newFG.get('expensePaid')?.invalid"
                                            formControlName="expensePaid" autocomplete="off" [min]="0" [maxFractionDigits]="0">
                                        </p-inputnumber>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="recoveryAmount">Recovery</label>
                                    </div>
                                    <div>
                                        <p-inputnumber id="recoveryAmount" name="recoveryAmount" mode="currency" value=""
                                            placeholder="Enter Recovery Amount $0" locale="en-US" currency="USD"
                                            [class.invalidInputNumber]="isAddEditButtonClicked && newFG.get('recovery')?.invalid"
                                            formControlName="recovery" autocomplete="off" [min]="0" [maxFractionDigits]="0">
                                        </p-inputnumber>
                                    </div>
                                </div>
                                <div class="col">
                                    <div>
                                        <label for="lossStatus">Loss Status</label>
                                    </div>
                                    <div>
                                        <p-select id="lossStatus" name="lossStatus" [options]="typeOfLossStatus"
                                            [class.validateDrodown]="isAddEditButtonClicked && newFG.get('lossStatus')?.invalid"
                                            placeholder="Select" appendTo="body" formControlName="lossStatus">
                                        </p-select>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    }
                    <div class="col-md-12 px-2 mt-3">
                        <span class="text-lg-right float-lg-right">
                            @if(fourYearLossHistoryFormGroup.selectedRowIndex === null) {
                                <button class="btnsuccess mr-2" title="Reset" name="reset" id="reset" data-toggle="modal"
                                    (click)="fourYearLossHistoryFormGroup.resetLossFormGroup()" type="button">
                                    <i class="fa fa-refresh" aria-hidden="true"></i> Reset
                                </button>
                            }                            
                            <button type="button" name="addLoss" id="btnAddLoss" class="btnsuccess"
                                [class.button-invalid]="isSubmitted && (fourYearLossHistoryFormGroup.lossHistoryFormArray?.length === 0 || fourYearLossHistoryFormGroup.newLossHistory?.hasTouched)"
                                title="{{fourYearLossHistoryFormGroup.selectedRowIndex !== null ? 'Update Loss' : 'Add Loss'}}" data-toggle="modal" (click)="SubmitAddedOrUpdatedLoss()">
                                {{ fourYearLossHistoryFormGroup.selectedRowIndex !== null ? 'Update Loss' : 'Add Loss' }}
                            </button>
                        </span>                        
                    </div>
                </p-card>
            </div>
        </div>
    </p-dialog>
</div>
